import config from '../../config';

export default function ignoreServerErrors() {
  const rules = [];
  let ignoring = false;

  function turnOff() {
    ignoring = false;
  }

  return {
    $get($rootScope) {
      'ngInject';

      return {
        ignoreInCurrentDigestCycle,
        shouldIgnore,
        isIgnoring: () => ignoring,
      };

      function ignoreInCurrentDigestCycle() {
        ignoring = true;
        $rootScope.$$postDigest(turnOff);
      }

      function shouldIgnore(error) {
        return rules.some(
          (rule) =>
            error.status === rule.statusCode &&
            (!rule.method || rule.method.toUpperCase() === error.config.method.toUpperCase()) &&
            _matchesRoutes(rule, error.config.url)
        );
      }

      function _matchesRoutes(rule, urlArg) {
        const url =
          urlArg.indexOf(config.API_END_POINT) === 0
            ? urlArg.substr(config.API_END_POINT.length)
            : urlArg;

        if (!rule.routes.length) {
          return true;
        }

        return rule.routes.some((route) => route.test(url));
      }
    },
    setRule(statusCode, method = null, routes = []) {
      rules.push({ statusCode, method, routes });
    },
  };
}
